/**
 * Quick view: any [data-quick-view="<product url>"] link opens the product
 * in the quick view drawer. Content is server-rendered by
 * sections/quick-view-content.liquid; without JavaScript the link simply
 * goes to the product page.
 */
import { overlays, events } from '@theme/core';

const cache = new Map();

async function load(url) {
  if (cache.has(url)) return cache.get(url);
  const separator = url.includes('?') ? '&' : '?';
  const response = await fetch(`${url}${separator}section_id=quick-view-content`);
  if (!response.ok) throw new Error(`Quick view failed: ${response.status}`);
  const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
  const html = doc.querySelector('[data-quick-view-product]')?.outerHTML;
  if (!html) throw new Error('Quick view: no product');
  cache.set(url, html);
  return html;
}

document.addEventListener('click', async (event) => {
  const trigger = event.target.closest('[data-quick-view]');
  if (!trigger || event.metaKey || event.ctrlKey || event.shiftKey) return;

  const panel = overlays.get('quick-view');
  const content = panel?.querySelector('[data-quick-view-content]');
  if (!content) return;

  event.preventDefault();
  content.setAttribute('aria-busy', 'true');

  try {
    content.innerHTML = await load(trigger.dataset.quickView);
    panel.show(trigger);
    events.emit('quickview:open', { url: trigger.dataset.quickView });
  } catch {
    window.location.href = trigger.href || trigger.dataset.quickView;
  } finally {
    content.removeAttribute('aria-busy');
  }
});

// Prefetch on hover intent so the drawer opens instantly
document.addEventListener(
  'pointerover',
  (event) => {
    const trigger = event.target.closest?.('[data-quick-view]');
    if (trigger && event.pointerType === 'mouse') load(trigger.dataset.quickView).catch(() => {});
  },
  { passive: true },
);
